import React, { useState, useMemo } from 'react';
import { priceToReadable } from 'utils/Helpers';
import { PAYMENT_STATES, PAYMENT_TYPES } from 'utils/Constants';

import Modal from 'components/Modal';
import Pill from 'components/Misc/Pill';
import { Title } from 'components/Misc/Typography';
import { Button, Datepicker, Currency, Select } from 'components/Misc/Form';

import { useStudentPaymentStore } from 'store/user/useStudentPaymentStore';

const Payment = ({ payment }) => {
	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Store additional information
	const type = useMemo(() => PAYMENT_TYPES.find(type => type.value === payment.type), [payment]);
	const state = useMemo(() => PAYMENT_STATES.find(state => state.value === payment.state), [payment]);

	// Use user's creation store
	const [onChangePayment, onRemovePayment] = useStudentPaymentStore(state => [
		state.onChangePayment,
		state.onRemovePayment
	]);

	// Handle payment data change
	const onChange = change => onChangePayment(payment.key, change);

	// Handle payment remote
	const onRemove = () => onRemovePayment(payment.key);

	// Toggle modal's visibility
	const handleModal = () => setModal(m => !m);

	return (
		<>
			<div className="py-2 px-3 flex items-center space-x-2 border border-neutral-200 dark:border-neutral-700 rounded-lg">
				<Title
					title={type?.text}
					className="flex-1"
				/>

				<Pill
					name={`${priceToReadable(payment.paid)} - ${priceToReadable(payment.amount)}`}
				/>

				<Pill
					name={state?.text}
					theme={state?.theme}
				/>

				<Datepicker
					readOnly
					value={payment.deadlineAt}
				/>
			
				<Button
					small
					square
					icon="edit"
					theme="warning"
					onClick={handleModal}
				/>

				<Button
					small
					square
					icon="close"
					theme="danger"
					onClick={onRemove}
				/>
			</div>

			<Modal title="Labot maksājumu" visible={modal} handleModal={handleModal}>
				<div className="grid grid-cols-2 gap-4">
					<Select
						name="type"
						label="Tips"
						placeholder=" "
						value={payment.type}
						onChange={onChange}
						options={PAYMENT_TYPES.map(type => ({
							value: type.value, name: type.text
						}))}
					/>

					<Select
						name="state"
						label="Status"
						placeholder=" "
						value={payment.state}
						onChange={onChange}
						options={PAYMENT_STATES.map(state => ({
							value: state.value, name: state.text
						}))}
					/>

					<Currency
						name="amount"
						label="Maksājamā summa"
						value={payment.amount}
						onChange={onChange}
					/>

					<Currency
						name="paid"
						label="Apmaksātā summa"
						value={payment.paid}
						max={payment.amount}
						onChange={onChange}
					/>

					<Datepicker
						asInput
						name="deadlineAt"
						label="Termiņš"
						value={payment.deadlineAt}
						onChange={onChange}
					/>

					<div className="col-span-2 flex justify-end">
						<Button
							icon="check"
							theme="success"
							value="Saglabāt"
							onClick={handleModal}
						/>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default Payment;